<script>

  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";
  import {makeWebsiteRequest} from "../../Common/tools";

  export let query;

  let table = null;
  let loading = false;
  let tableData = {
    columns: [
      { key: "name", label: M.NAME, class: "flex-1 mw-240" },
      { key: "email", label: M.EMAIL, class: "flex-none" },
      { key: "stepName", label: M.STEP, class: "flex-none" },
      { key: "startTime", label: M.ENTERED_FLOW, class: "flex-none" }
    ],
    rows: []
  };

  let currentPage = 1;
  let pagesCount = 0;
  let itemsPerPage = 0;

  const STEP_TYPE_LABELS = {
    DELAY: M.DELAY,
    IF_ELSE: M.IFELSE,
    SPLIT: M.SPLIT,
    TARGET: M.TARGET,
    SEND_EMAIL: M.SEND_EMAIL,
    SEND_EMAIL_NOTIFICATION: M.SEND_EMAIL_NOTIFICATION,
    CONTACT_TAG_ADD: M.CONTACT_TAG_ADD,
    CONTACT_TAG_REMOVE: M.CONTACT_TAG_REMOVE,
    CONTACT_PROPERTY_CHANGE: M.CONTACT_PROPERTY_CHANGE,
    CONTACT_NOTE_ADD: M.CONTACT_NOTE_ADD,
    CONTACT_DELETE: M.CONTACT_DELETE,
    CONTACT_LIST_ADD: M.CONTACT_LIST_ADD,
    CONTACT_LIST_REMOVE: M.CONTACT_LIST_REMOVE,
    CONTACT_UNSUBSCRIBE: M.CONTACT_UNSUBSCRIBE,
    START_AUTOMATION: M.START_AUTOMATION,
    END_AUTOMATION: M.EXITED_AUTOMATION,
    TRIGGER_WEBHOOK: M.TRIGGER_WEBHOOK,
    SEND_SMS: M.SEND_SMS,
    SEND_WHATSAPP: M.SEND_WHATSAPP,
    SEND_VOICE: M.SEND_VOICE
  }

  const loadUsers = async (page, append) => {
    if (loading) {
      return;
    }

    loading = true;

    const id = External.WebPlatform.getUrlQueryParameter(window.location.href, "id");

    let response = await makeWebsiteRequest({
      action: "getAutomationUsers",
      data: {
        id: id,
        skip: page * itemsPerPage,
        query: query
      }
    });

    if (!response.data) {
      loading = false;
      return;
    }

    tableData.count = response.data.count;
    pagesCount = response.data.pagesCount;
    itemsPerPage = response.data.itemsPerPage;
    currentPage = page;

    let items = response.data.items;
    items.forEach((item) => {
      item.stepName = getStepDesc(item.stepType, item.stepName);
      item.startTime = item.startTime ? External.Tools.dateToString(new Date(item.startTime), true) : "";
    });

    if (append) {
      tableData.rows = tableData.rows.concat(items);
    } else {
      tableData = Object.assign({}, tableData, {rows: items});
    }

    loading = false;
  }

  const getStepDesc = (stepType, stepName) => {
    if (stepName) {
      if (stepName === "start") {
        return M.STARTED;
      }
      return STEP_TYPE_LABELS[stepType] ? STEP_TYPE_LABELS[stepType] + " - " + stepName : stepName;
    }
    return M.EXITED_AUTOMATION;
  }

  const onClick = (row) => {
    External.CPanel.goToUrl("/me/crm/contact/" + row.contactId, true);
  };

  const getNextPage = () => {
    if (loading) {
      return;
    }
    if (tableData.count === null || currentPage + 1 >= pagesCount) {
      return;
    }
    loadUsers(currentPage + 1, true);
  };

  export const reloadData = () => {
    loadUsers(0, false);
  }

  onMount(() => {
    reloadData();
  });

</script>

{#if loading || tableData.rows.length > 0}
  <Table data={tableData.rows} activeColumns={tableData.columns} onClick={onClick} loading={loading} nextPage={getNextPage} hasSelection={false} />
{:else}
  <div class="text-center mt-25">
    <h5>{M.NO_DATA_YET}</h5>
  </div>
{/if}
